/**
 * Created by staffanrantzow on 19/04/16.
 */

import React, {PropTypes} from 'react';
import InvoiceRow from './invoice-row';
import Translate from 'react-translate-component';

export class InvoicesTable extends React.Component {

  static propTypes = {
    invoices: PropTypes.array.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      showMoreList: {
        invoiceId: null,
        show: false
      }
    };

    this.setShowMoreList = this.setShowMoreList.bind(this);
    this.resetShowMoreList = this.resetShowMoreList.bind(this);
  }

  setShowMoreList (invoiceId) {
    const invoiceIdSet = this.state.showMoreList.invoiceId === invoiceId;
    this.setState({
      showMoreList: {
        invoiceId: invoiceIdSet ? null : invoiceId,
        show: !invoiceIdSet
      }
    });
  };

  resetShowMoreList () {
    this.setState({
      showMoreList: {
        invoiceId: null,
        show: false
      }
    });
  }

  renderRow (invoice, i) {
    return <InvoiceRow
      key={i}
      invoice={invoice}
      toggleShowMoreList={this.setShowMoreList}
      resetShowMoreList={this.resetShowMoreList}
      showMoreList={this.state.showMoreList}
    />;
  }

  render () {
    return (
      <table className='invoices-table'>
        <thead>
          <tr className='invoices-table-header'>
            <th className='invoice-table-header-column'>
              <Translate content='INVOICES_TABLE_TITLE_CREATED'/>
            </th>
            <th className='invoice-table-header-column'>
              <Translate content='INVOICES_TABLE_TITLE_CUSTOMER'/>
            </th>
            <th className='invoice-table-header-column hide-mobile'>
              <Translate content='INVOICES_TABLE_TITLE_ORDER_NUMBER'/>
            </th>
            <th className='invoice-table-header-column'>
              <Translate content='INVOICES_TABLE_TITLE_SUM_EXCL_VAT'/>
            </th>
            <th className='invoice-table-header-column hide-mobile'>
              <Translate content='INVOICES_TABLE_TITLE_STATUS'/>
            </th>
            <th className='invoice-table-header-column'>
              <Translate content='INVOICES_TABLE_TITLE_MORE'/>
            </th>
          </tr>
        </thead>
        <tbody>
          {this.props.invoices.map(this.renderRow.bind(this))}
        </tbody>
      </table>
    );
  }

}

export default InvoicesTable;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/invoices/table-content/invoices-table.js
 **/